import React, { useEffect, useState } from 'react';
import styles from './RecordingStudio.module.scss';
import { Icon } from '../../../engage/components/Icon';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../components/Button/Button';
import electricLight from '../../assets/electricLight.png';
import CmsAPI from '../../../common/apis/CmsAPI';

export const RecordingStudio = () => {
  const [isShowTooltip, setIsShowTooltip] = useState(true);

  const { t } = useTranslation();

  const listenerFunc = async event => {
    const extensionId = process.env.EXT_ID;
    // We only accept messages from this window to itself [i.e. not from any iframes]
    if (event.source !== window) return;


    if (event.data.type && event.data.type === `${extensionId}-extension`) {
      switch (event.data.message) {
        case 'USER_MADE_A_CLIP':
          if (event.data.storyId) {
            localStorage.setItem('recordedStoryId', event.data.storyId);
            localStorage.setItem('isClipRecording', false);
          }
          break;
        case 'USER_MAKES_A_DRAFT_SCENE':
          if (event.data.sceneId) {
            localStorage.setItem('draftSceneId', event.data.sceneId);
            localStorage.setItem('isClipRecording', true);
          }
          break;
        case 'USER_CANCEL_A_DRAFT_SCENE':
          localStorage.setItem('userCancelDraftScene', true);
          localStorage.removeItem('draftSceneId');
          localStorage.setItem('isClipRecording', false);
          break;
        case 'USER_RECORDED_A_DRAFT_SCENE':
          localStorage.removeItem('draftSceneId');
          localStorage.setItem('isClipRecording', false);
          break;
        case 'USER_STARTED_RECORDING':
          setIsShowTooltip(false);
          localStorage.setItem('isClipRecording', true);
          break;
        case 'SAVE_UPDATED_SCRIPT':
          await CmsAPI.updateScene(event.data.sceneId, {
            id: event.data.sceneId,
            storyId: event.data.storyId,
            script: event.data.script,
          });
          localStorage.setItem(
            'updateClipScript',
            JSON.stringify({ storyId: event.data.storyId, sceneId: event.data.sceneId, script: event.data.script })
          );
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    const extensionId = process.env.EXT_ID;
    window.postMessage({ type: extensionId, message: 'INITIATE_RECORDING' }, '*');
  }, []);

  useEffect(() => {
    const onBeforeUnload = event => {
      // Included for legacy support, e.g. Chrome/Edge < 119
      localStorage.setItem('isClipRecording', false);
      localStorage.removeItem('draftSceneId');
    };
    window.addEventListener('message', listenerFunc);

    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('message', listenerFunc);
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);

  const handleEndRecording = () => {
    const extensionId = process.env.EXT_ID;
    window.postMessage({ type: extensionId, message: 'END_RECORDING' }, '*');
  };

  return (
    <>
      <div className={styles.logoContainer}>
        <Icon src={'logo'} className={styles.iconLogo} />
      </div>
      <div className={styles.descriptionContainer}>
        <img src={electricLight} className={styles.electricLightLogo} alt={t('logo_chooser.header')} />
        <span className={styles.title}>{t('recording_studio.main_title')}</span>
        <span className={styles.text}>{t('recording_studio.main_text')}</span>
        <CustomButton
          variant="secondary"
          label={t('recording_studio.end_recording')}
          onClick={handleEndRecording}
          className={styles.stopButton}
        />
      </div>
      {isShowTooltip && (
        <div className={styles.tooltipContainer}>
          <div className={styles.tooltipText}>
            <span>{t('recording_studio.tooltip')}</span>
          </div>
          <Icon src="vectorStudio" className={styles.vectorStudio} />
        </div>
      )}
    </>
  );
};
